<template>
  <div class="RecyclingOutlets" v-fullscreen="fullscreen">
    <div v-if="checkRoles()" class="permission-modal">
      <!-- 背景蒙层 -->
      <div class="modal-backdrop"></div>

      <!-- 弹窗内容 -->
      <div class="modal-container">
        <div class="modal-card">
          <!-- 顶部图标 -->
          <div class="modal-icon">
            <i class="el-icon-lock"></i>
          </div>

          <!-- 标题 -->
          <h3 class="modal-title">温馨提示</h3>

          <!-- 内容 -->
          <p class="modal-message">
            您暂无查看权限，如需浏览，请联系工作人员开通服务
          </p>

          <!-- 操作按钮 -->
          <div class="modal-actions">
            <el-button
              type="primary"
              size="medium"
              @click="conditionalGoBack"
              class="back-button"
            >
              返回上级目录
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="RecyclingOutlets-head">
        <div class="RecyclingOutlets-head-weather headContent">
          <div
            @click="goHome"
            class="RecyclingOutlets-head-weather-back parallelogram"
          >
            <span class="content">返回</span>
          </div>
          <div class="RecyclingOutlets-head-weather-time">
            <img
              class="dateImg"
              :title="todayWeather.dayweather"
              :src="weatherImg[todayWeather.dayweather]"
              alt="天气预报"
            />
            <div class="timeDate">
              <div class="timeDate_top">{{ time }}</div>
              <div class="timeDate_btn">
                {{ todayWeather.city }}
                <span
                  >{{ todayWeather.nighttemp }}℃-{{
                    todayWeather.daytemp
                  }}℃</span
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="RecyclingOutlets-head-title headContent"
          :class="title.length > 18 ? 'changeTitleSize' : ''"
        >
          {{ title }}
        </div>
        <div class="RecyclingOutlets-head-action headContent">
          <div class="date">
            <el-cascader
              v-if="$store.state.echartsMap.dataType == 2"
              ref="timeCascader"
              v-model="timeValue"
              placeholder="请选择日期"
              @change="choseTime"
              class="zszy_cascader"
              :options="options"
              :popper-append-to-body="false"
            />
            <el-select
              class="yearSelect"
              v-else
              v-model="timeValue"
              @change="changeTime"
              placeholder="请选择日期"
            >
              <el-option
                v-for="item in yearPptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div
            class="RecyclingOutlets-head-action-area RecyclingOutlets-head-action-area-flex"
          >
            <div
              class="parallelogram"
              :class="{ checkedBanner: $store.state.echartsMap.dataType == 1 }"
              @click="switchData(1)"
            >
              <span class="content">全省数据</span>
            </div>
            <div
              class="parallelogram"
              :class="{ checkedBanner: $store.state.echartsMap.dataType == 2 }"
              style="margin-left: 2px"
              @click="switchData(2)"
            >
              <span class="content">供销系统数据</span>
            </div>
          </div>
          <div
            class="parallelogram RecyclingOutlets-head-action-search RecyclingOutlets-head-action-area-flex"
            v-if="false"
          >
            <img class="content search" :src="search" alt="搜索" />
          </div>
          <div
            v-if="!fullscreen"
            class="parallelogram RecyclingOutlets-head-action-search RecyclingOutlets-head-action-area-flex"
          >
            <div class="content" @click="screen">全屏</div>
          </div>
          <div
            v-else
            class="parallelogram RecyclingOutlets-head-action-area-flex"
          >
            <div class="content" @click="screen">退出全屏</div>
          </div>
        </div>
      </div>
      <div class="RecyclingOutlets-content">
        <div
          class="RecyclingOutlets-content-left"
          v-if="$store.state.echartsMap.isLower"
        >
          <div class="rectangle_level1">
            <data-gglance
              :areaTopData="areaTopData"
              :materials="materials"
              @goTopLevel="goTopLevel"
            />
          </div>
          <div class="rectangle_level2">
            <growing-trends :growthTrendData="growthTrendData" />
          </div>
        </div>
        <div
          class="RecyclingOutlets-content-left"
          v-if="!$store.state.echartsMap.isLower"
        >
          <div class="rectangle1">
            <data-overview :mapData="mapData" />
          </div>
          <div class="rectangle2">
            <recycling-trends />
          </div>
          <div class="rectangle3">
            <recycling-type
              :fullscreen="fullscreen"
              :mapData="mapData"
              :materials="materials"
            />
          </div>
        </div>
        <div class="RecyclingOutlets-content-map">
          <resource-map :resourceData="resourceData" :mapData="mapData" />
        </div>
        <div class="RecyclingOutlets-content-right">
          <div class="rectangle4">
            <carbon-emission :mapData="mapData" />
          </div>
          <div class="rectangle5">
            <waste-materials :materials="materials" />
          </div>
        </div>
      </div>
      <div class="RecyclingOutlets-btn"></div>
    </template>
  </div>
</template>

<script>
import resourceMap from '@/views/IndustryMap/components/resourceMap.vue';
import carbonEmission from '@/views/IndustryMap/components/carbonEmission.vue';
import wasteMaterials from '@/views/IndustryMap/components/wasteMaterials.vue';
import DataOverview from '@/views/IndustryMap/components/dataOverview.vue';
import recyclingTrends from '@/views/IndustryMap/components/recyclingTrends.vue';
import recyclingType from '@/views/IndustryMap/components/recyclingType.vue';
import dataGglance from '@/views/IndustryMap/components/dataGglance.vue';
import growingTrends from '@/views/IndustryMap/components/growingTrends.vue';
import { DateFormat } from '@/util/dateFormat';
import allAdcode from '@/components/echartsMenu/json/allAdcode.json';
import axios from 'axios';
import {
  getAmountOfDismantling,
  getStatiosTypedata,
  getCategories,
} from '@/API/echarts/echarts';
import { siChuanAdcode } from '@/util/filterAdcode';
import { Message } from 'element-ui';
export default {
  name: 'index.vue',
  components: {
    DataOverview,
    resourceMap,
    carbonEmission,
    wasteMaterials,
    recyclingTrends,
    recyclingType,
    dataGglance,
    growingTrends,
  },
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('ordinaryUser')),
      vipStartTime: this.userInfo?.userDetail?.memberStartTime || false,
      vipEndTime: this.userInfo?.userDetail?.memberEndTime || false,
      nowTime: new Date().getTime(),
      title: '天府再生资源云平台数据大屏',
      weather: require('@/assets/recycling/weatherImg/多云.svg'),
      search: require('@/assets/recycling/echartsMap/search.svg'),
      nowDate: '',
      fullscreen: false,
      OverView: [],
      todayWeather: {
        daytemp: '',
        nighttemp: '',
        dayweather: '',
        city: '',
      },
      time: '',
      mapTimer: '',
      weatherImg: {
        多云: require('@/assets/recycling/weatherImg/多云.svg'),
        晴: require('@/assets/recycling/weatherImg/晴.svg'),
        阴: require('@/assets/recycling/weatherImg/阴天.svg'),
        阵雨: require('@/assets/recycling/weatherImg/阵雨.svg'),
        雷阵雨: require('@/assets/recycling/weatherImg/雷阵雨.svg'),
        雷阵雨伴有冰雹: require('@/assets/recycling/weatherImg/雷阵雨伴有冰雹.svg'),
        雨夹雪: require('@/assets/recycling/weatherImg/雨夹雪.svg'),
        小雨: require('@/assets/recycling/weatherImg/小雨.svg'),
        中雨: require('@/assets/recycling/weatherImg/中雨.svg'),
        大雨: require('@/assets/recycling/weatherImg/大雨.svg'),
        暴雨: require('@/assets/recycling/weatherImg/暴雨.svg'),
        大暴雨: require('@/assets/recycling/weatherImg/大暴雨.svg'),
        特大暴雨: require('@/assets/recycling/weatherImg/特大暴雨.svg'),
        阵雪: require('@/assets/recycling/weatherImg/阵雨.svg'),
        小雪: require('@/assets/recycling/weatherImg/小雪.svg'),
        中雪: require('@/assets/recycling/weatherImg/中雪.svg'),
        大雪: require('@/assets/recycling/weatherImg/大雪.svg'),
        暴雪: require('@/assets/recycling/weatherImg/暴雪.svg'),
        雾: require('@/assets/recycling/weatherImg/雾.svg'),
        冻雨: require('@/assets/recycling/weatherImg/冻雨.svg'),
        沙尘暴: require('@/assets/recycling/weatherImg/沙尘暴.svg'),
        小雨转中雨: require('@/assets/recycling/weatherImg/小雨转中雨.svg'),
        中雨转大雨: require('@/assets/recycling/weatherImg/中雨转大雨.svg'),
        大雨转暴雨: require('@/assets/recycling/weatherImg/大雨转暴雨.svg'),
        暴雨转大暴雨: require('@/assets/recycling/weatherImg/暴雨转大暴雨.svg'),
        大暴雨转特大暴雨: require('@/assets/recycling/weatherImg/大暴雨转特大暴雨.svg'),
        小雪转中雪: require('@/assets/recycling/weatherImg/小雪转中雪.svg'),
        中雪转大雪: require('@/assets/recycling/weatherImg/中雪转大雪.svg'),
        大雪转暴雪: require('@/assets/recycling/weatherImg/大雪转暴雪.svg'),
        浮尘: require('@/assets/recycling/weatherImg/浮尘.svg'),
        扬沙: require('@/assets/recycling/weatherImg/扬沙-右下.svg'),
        强沙尘暴: require('@/assets/recycling/weatherImg/强沙尘暴.svg'),
        霾: require('@/assets/recycling/weatherImg/霾.svg'),
      },
      dataType: window.localStorage.getItem('dataType') || '',
      options: this.getYear(),
      yearPptions: this.getNewYear(),
      timeValue: [String(new Date().getFullYear() - 1), 0],
      mapData: {},
      materials: [],
      resourceData: [],
      dataTimer: null,
      areaTopData: [], //地区排名
      growthTrendData: [], //增长趋势
    };
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        if (newPath !== '/recyclingOutlets') {
          this.destroyCompanyCardModal();
        }
      },
    },
    '$store.state.echartsMap.cityName': {
      handler: function (val) {
        this.addData(this.$store.state.echartsMap.dataType, val);
      },
    },
    '$store.state.echartsMap.dataType': {
      handler: function (val) {
        // let glanceType = this.$store.state.echartsMap.glanceType;
        // if (glanceType) {
        //   this.getStationsData(glanceType.id, glanceType.typeValue);
        // } else {
        //   this.addData(val, this.$store.state.echartsMap.cityName);
        // }
        // 根据客户需求，切换省份返回最顶层数据和界面
        this.addData(val, '四川省');
      },
    },
    '$store.state.echartsMap.timeRange': {
      handler: function (val) {
        if (this.$store.state.echartsMap.glanceType) {
          let glanceType = this.$store.state.echartsMap.glanceType;
          let id = glanceType.id;
          let typeValue = glanceType.typeValue;
          this.getStationsData(id, typeValue);
        } else {
          this.addData(
            this.$store.state.echartsMap.dataType,
            this.$store.state.echartsMap.cityName,
          );
        }
      },
    },
    '$store.state.echartsMap.glanceType': {
      handler: function (val) {
        console.log(val, 'valvalval');
        if (val) {
          this.getStationsData(val.id, val.typeValue);
          this.title = `天府再生资源云平台数据大屏-${val.typeName}`;
        } else {
          this.title = `天府再生资源云平台数据大屏`;
        }
      },
    },
    '$store.state.echartsMap.isLower': {
      handler: function (val) {
        if (!val) {
          this.$store.state.echartsMap.glanceType = undefined;
        }
      },
    },
  },
  mounted() {
    // 初始化数据
    this.$store.state.echartsMap.isLower = false;
    this.getTime();
    this.getWeather();
    this.updateTimeAndWeather();
    // 监听全屏变化事件（修复：增加webkit和moz前缀兼容）
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener(
      'webkitfullscreenchange',
      this.handleFullscreenChange,
    );
    document.addEventListener(
      'mozfullscreenchange',
      this.handleFullscreenChange,
    );

    // 监听F11按键事件（修复：正确处理F11事件）
    document.addEventListener('keydown', (e) => {
      if (e.key === 'F11') {
        e.preventDefault(); // 阻止默认F11行为
        this.toggleFullscreen(); // 使用统一的切换方法
      }
    });
    this.addData(2, '四川省');
  },
  methods: {
    destroyCompanyCardModal() {
      const modalElement = document.getElementById('componyCard');
      if (modalElement) {
        // 如果弹窗有Vue实例，先销毁Vue实例
        if (modalElement.__vue__) {
          modalElement.__vue__.$destroy();
        }

        // 移除DOM元素
        modalElement.remove();

        // 如果存在背景蒙层，也一并移除
        const backdrop = document.querySelector('.componyCard-backdrop');
        if (backdrop) {
          backdrop.remove();
        }

        console.log('componyCard弹窗已销毁');
      }
    },
    getYear() {
      let yearList = [];
      let nowYear = new Date().getFullYear();
      for (let i = 1; i < 6; i++) {
        yearList.push({
          value: `${nowYear - i}`,
          label: `${nowYear - i}年`,
          children: [
            {
              value: 0,
              label: '全年',
            },
            {
              value: 1,
              label: '一季度',
            },
            {
              value: 2,
              label: '二季度',
            },
            {
              value: 3,
              label: '三季度',
            },
            {
              value: 4,
              label: '四季度',
            },
          ],
        });
      }
      return yearList;
    },
    getNewYear() {
      let yearList = [];
      let nowYear = new Date().getFullYear();
      for (let i = 1; i < 6; i++) {
        yearList.push({
          value: `${nowYear - i}`,
          label: `${nowYear - i}年`,
        });
      }
      return yearList;
    },
    // 获取站点详情数据
    getStationsData(id, typeValue) {
      this.resourceData = []; // 销售额-销售量
      this.materials = []; // 回收-拆解量
      this.areaTopData = []; // 地区排名
      this.growthTrendData = []; // 增长趋势
      let type = this.$store.state.echartsMap.dataType == 1 ? 1031 : 1030; //1030省社,1031全省
      let clickRegionCode = allAdcode.filter(
        (areaJson) => areaJson.name === this.$store.state.echartsMap.cityName,
      )[0].adcode;
      getStatiosTypedata(id, typeValue, {
        type: type,
        adcode: clickRegionCode,
        timestr: this.$store.state.echartsMap.timeRange[0],
        quarter: this.$store.state.echartsMap.timeRange[1],
      }).then((res) => {
        if (res.code == 200) {
          this.materials = res.data?.typeDataMaterialData
            ? res.data.typeDataMaterialData
            : [];

          this.areaTopData = res.data?.areaTopData ? res.data.areaTopData : [];

          this.growthTrendData = res.data?.growthTrendData
            ? res.data.growthTrendData
            : [];
          // 存储地图聚合撒点数据
          this.$store.commit(
            'echartsMap/changeMapIconTotle',
            res.data.typeCountData,
          );
          res.data?.typeDataMaterialData.forEach((item) => {
            if (item.type == 10218 || item.type == 10219) {
              this.resourceData.push(item);
            }
          });
          console.log(this.resourceData, 'this.resourceDatathis.resourceData');
        }
      });
    },
    choseTime(value) {
      this.$store.commit('echartsMap/changeTimeRange', value);
    },
    changeTime(value) {
      this.$store.commit('echartsMap/changeTimeRange', [value, 0]);
    },
    goHome() {
      window.history.back();
      this.destroyCompanyCardModal();
    },
    // 获取大屏数据
    addData(dataType, cityName) {
      this.mapData = {};
      this.materials = [];
      let type = dataType == 1 ? 1031 : 1030; //1030省社,1031全省
      // let data = {
      //   type: type,
      //   timestr: this.timeValue[0],
      //   quarter: this.timeValue[1],
      // };
      // 根据用户需求，修改逻辑，并添加注释标注
      let data = {
        type: type,
        timestr: dataType == 1 ? this.timeValue : this.timeValue[0],
        quarter: dataType == 1 ? 0 : this.timeValue[1],
      };
      let adCode = siChuanAdcode[cityName];
      getAmountOfDismantling(adCode, data).then((res) => {
        if (res.code == 200) {
          this.mapData = res.data ? Object.assign({}, res.data) : {};
          this.materials = res.data?.materials ? res.data.materials : [];
        }
      });
    },
    goTopLevel() {
      this.addData(
        this.$store.state.echartsMap.dataType,
        this.$store.state.echartsMap.cityName,
      );
    },
    // 切换全省社数据
    switchData(val) {
      this.$store.commit('echartsMap/changeDataType', val);
      this.$store.commit('echartsMap/changeGlanceType', undefined);
      // 根据用户需求，修改逻辑，并添加注释标注
      if (val == 1) {
        this.timeValue = String(new Date().getFullYear() - 1);
      } else {
        this.timeValue = [String(new Date().getFullYear() - 1), 0];
      }
    },
    getWeather() {
      axios
        .get('https://restapi.amap.com/v3/weather/weatherInfo', {
          params: {
            key: '8ce1786d87100ab8f6658c3404ecd3f9',
            city: 510100,
            extensions: 'all', // base:返回实况天气 all:返回预报天气
          },
        })
        .then((res) => {
          console.log(res.data, 'resresresres');
          this.todayWeather.daytemp = res.data.forecasts[0].casts[0].daytemp;
          this.todayWeather.nighttemp =
            res.data.forecasts[0].casts[0].nighttemp;
          this.todayWeather.dayweather =
            res.data.forecasts[0].casts[0].dayweather;
          this.todayWeather.city = res.data.forecasts[0].city;
        });
    },
    getTime() {
      this.time = DateFormat(new Date(), 'yyyy-MM-dd W');
      this.$store.state.echartsMap.timeHistory = this.time;
    },
    screen() {
      this.toggleFullscreen(); // 使用统一的切换方法
    },
    handleFullscreenChange() {
      this.fullscreen =
        !!document.fullscreenElement ||
        !!document.webkitFullscreenElement ||
        !!document.mozFullScreenElement;
    },
    // 修改：统一的全屏切换方法
    toggleFullscreen() {
      if (this.isFullscreen()) {
        this.exitFullscreen();
      } else {
        this.enterFullscreen();
      }
    },
    // 新增：检查是否处于全屏状态
    isFullscreen() {
      return (
        !!document.fullscreenElement ||
        !!document.webkitFullscreenElement ||
        !!document.mozFullScreenElement
      );
    },
    // 新增：进入全屏
    enterFullscreen() {
      const docEl = document.documentElement;
      if (docEl.requestFullscreen) {
        docEl.requestFullscreen();
      } else if (docEl.webkitRequestFullscreen) {
        docEl.webkitRequestFullscreen();
      } else if (docEl.mozRequestFullScreen) {
        docEl.mozRequestFullScreen();
      }
    },
    // 新增：退出全屏
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      }
    },

    // 0点更新时间和天气
    updateTimeAndWeather() {
      clearInterval(this.mapTimer);
      this.mapTimer = setInterval(() => {
        const time = DateFormat(new Date(), 'yyyy-MM-dd W');
        if (time !== this.$store.state.echartsMap.timeHistory) {
          this.getTime();
          this.getWeather();
        }
      }, 1000);
    },
    conditionalGoBack() {
      this.$router.push('/Home/pages');
    },
    checkRoles() {
      let userInfo = localStorage.getItem('ordinaryUser')
        ? JSON.parse(localStorage.getItem('ordinaryUser'))
        : null;
      let status;
      if (userInfo) {
        if (userInfo.userDetail.userType == 3) {
          // 政府用户
          status = false;
        } else {
          // 普通用户和企业用户
          if (userInfo.userDetail.memberStatus == 2) {
            //如果请求的最新数据memberStatus为2则vip过期
            status = true;
            return;
          }
          // 如果是历史数据则需判断当前时间是否在vip有效期内
          if (
            userInfo.userDetail.memberStartTime &&
            userInfo.userDetail.memberEndTime
          ) {
            let result =
              new Date(userInfo.userDetail.memberStartTime).getTime() <
                new Date().getTime() &&
              new Date(userInfo.userDetail.memberEndTime).getTime() >
                new Date().getTime();
            if (!result) {
              userInfo.userDetail.memberStartTime = null;
              userInfo.userDetail.memberEndTime = null;
              userInfo.userDetail.memberStatus = 0;
              localStorage.setItem('ordinaryUser', JSON.stringify(userInfo));
              status = true;
            } else {
              status = false;
            }
          } else {
            status = true;
          }
        }
      }
      return status;
    },
  },
  destroyed() {
    clearInterval(this.mapTimer);
  },
  beforeRouteLeave(to, from, next) {
    // 在路由离开前销毁弹窗，包括浏览器返回按钮触发的情况
    this.destroyCompanyCardModal();
    next();
  },
};
</script>

<style scoped lang="less">
.RecyclingOutlets {
  width: 100vw;
  position: relative;
  height: 100vh;
  background: url('~@/assets/recycling/echartsMap/mapBackground.png') no-repeat;
  background-size: cover;
  .mapShow {
    width: 100%;
    height: 100%;
  }
  .RecyclingOutlets-head {
    background: url('~@/assets/recycling/echartsMap/header.png') no-repeat;
    background-size: cover;
    height: 88px;
    width: 100%;
    display: flex;
    align-items: center;
    .headContent {
      flex: 1;
    }
    .RecyclingOutlets-head-title {
      display: flex;
      font-weight: 700;
      align-items: center;
      font-size: 32px;
      padding-right: 20px;
      color: #ffffff;
      justify-content: center;
    }
    .RecyclingOutlets-head-weather {
      padding-top: 65px;
      padding-left: 15px;
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      .RecyclingOutlets-head-weather-back {
        width: 79px;
        height: 32px;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
      }
      .RecyclingOutlets-head-weather-time {
        margin-left: 20px;
        font-size: 14px;
        height: 43px;
        width: 215px;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        .dateImg {
          width: 40px;
          height: 40px;
        }
        .timeDate {
          font-size: 14px;
          margin-left: 10px;
          color: #ffffff;
          .timeDate_top {
            font-weight: 500;
          }
          .timeDate_btn {
            margin-top: 5px;
            font-weight: 500;
            span {
              font-size: 14px;
              color: rgba(39, 255, 252, 1);
            }
          }
        }
      }
    }
    .RecyclingOutlets-head-action {
      padding-top: 65px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .date {
        margin-right: 16px;
        .el-select-dropdown__item.hover,
        .el-select-dropdown__item:hover {
          background: linear-gradient(
            90deg,
            rgba(31, 115, 159, 0.1) 0%,
            rgba(21, 154, 255, 0.1) 0%,
            rgba(153, 206, 251, 0.1) 100%
          );
          color: rgba(255, 252, 252, 1);
          font-size: 14px;
          font-weight: 500;
        }
        .el-select-dropdown {
          margin-top: 0 !important;
          max-width: 200px !important;
          background: rgba(6, 74, 119, 0.9);
          border: 1px solid rgba(77, 147, 201, 1);
        }
        .el-select-dropdown__item {
          color: rgba(153, 206, 251, 1);
        }
        /deep/.el-input__inner {
          opacity: 1;
          border-radius: 2px;
          background: rgba(6, 74, 119, 0.4);
          border: 1px solid rgba(77, 147, 201, 0.6);
          color: rgba(255, 255, 255, 1);
          font-size: 14px;
          font-weight: 400;
          height: 30px;
          text-align: left !important;
          transition: all linear 0.3s;
        }

        /deep/.el-input__inner:hover {
          border: 1px solid rgba(21, 153.99999999999994, 255, 1) !important;
        }

        /deep/.el-input__inner:focus {
          border: 1px solid rgba(26, 255, 251, 1) !important;
        }
        /deep/.el-select-dropdown {
          margin-top: 0 !important;
          max-width: 200px !important;
          background: rgba(6, 74, 119, 0.9);
          border: 1px solid rgba(77, 147, 201, 1);
        }

        /deep/.el-select-dropdown__item {
          color: rgba(153, 206, 251, 1);
        }
        /deep/.el-popper[x-placement^='bottom'] .popper__arrow {
          display: none;
        }
        /deep/.el-input__icon {
          line-height: 32px;
        }
        .zszy_cascader {
          line-height: 32px;
          /deep/.el-input__inner {
            height: 32px;
          }
        }
      }
      .RecyclingOutlets-head-action-area {
        display: flex;
      }
      .RecyclingOutlets-head-action-search {
        width: 59px;
        height: 32px;
      }
      .RecyclingOutlets-head-action-area-flex {
        margin-right: 20px;
        .search {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .yearSelect {
    /deep/ .el-input__inner {
      height: 32px !important;
    }
  }
  .RecyclingOutlets-content {
    margin-top: 35px;
    width: 100%;
    height: calc(100% - 160px);
    display: flex;
    .RecyclingOutlets-content-left,
    .RecyclingOutlets-content-right {
      flex: 2.5;
      height: 100%;
      .rectangle4,
      .rectangle5 {
        width: 100%;
        height: 49.244%;
        margin-top: 10px;
      }
    }
    .RecyclingOutlets-content-right {
      margin-right: 20px;
    }
    .RecyclingOutlets-content-left {
      margin-left: 20px;
      .rectangle_level1,
      .rectangle_level2 {
        width: 100%;
        height: 49.83%;
      }
      .rectangle_level1 {
        margin-bottom: 10px;
      }
      .rectangle1 {
        width: 100%;
        height: 36%;
        margin-bottom: 10px;
      }
      .rectangle2,
      .rectangle3 {
        width: 100%;
        height: 31.26%;
      }
      .rectangle2 {
        margin-bottom: 10px;
      }
    }
    .RecyclingOutlets-content-map {
      flex: 5;
      height: 100%;
    }
  }
  .RecyclingOutlets-btn {
    height: 26.5px;
    background: url('~@/assets/recycling/echartsMap/btnLogo.png') no-repeat;
    background-size: cover;
  }
}
// 按钮公共样式
.parallelogram {
  width: 95px; /* 宽度 */
  height: 32px; /* 高度 */
  cursor: pointer;
  border-radius: 1px;
  background: linear-gradient(
    -15deg,
    rgba(0, 191, 255, 0.5) 0%,
    rgba(0, 191, 255, 0) 100%
  );
  border: 2px solid rgba(0, 0, 0, 0);
  box-shadow: 0px 4px 9px rgba(2, 6, 10, 0.35);
  transform: skew(20deg); /* 倾斜角度 */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 14px;
  font-family: Arial, sans-serif;
}
.parallelogram:hover {
  background: linear-gradient(
    180deg,
    rgba(0, 132, 255, 0.2) 0%,
    rgba(0, 191, 255, 1) 100%
  );
}
.checkedBanner {
  background: linear-gradient(
    180deg,
    rgba(0, 132, 255, 0.2) 0%,
    rgba(0, 191, 255, 1) 100%
  );
}
/* 如果需要内容不倾斜，可以在内部添加一个容器 */
.parallelogram::before {
  content: '';
  position: absolute;
  z-index: -1; /* 确保背景在内容下方 */
}
.content {
  transform: skew(-20deg); /* 反向倾斜以保持内容正常 */
}
::v-deep .el-scrollbar__wrap {
  margin-bottom: -9px !important;
}
.changeTitleSize {
  font-size: 28px !important;
}
.mengban {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('~@/assets/recycling/index/mengBanBg.png') no-repeat;
  background-size: cover;
  z-index: 10000000;
  .mengban_bg {
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px); /* 背景模糊 */
    background-color: rgba(255, 255, 255, 0.2); /* 白色半透明 */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    .mengban_bg_box {
      background-color: #ffffff;
      padding: 20px;
      border-radius: 5px;
      .mengban_tips {
        text-align: center;
        font-size: 26px;
        margin-bottom: 15px;
        color: #3b3c3f;
        font-weight: 600;
      }
    }
    .backFront {
      text-align: center;
      margin-top: 10px;
      cursor: pointer;
      color: #0686efff !important;
      font-size: 18px;
    }
    .backFront:hover {
      color: rgba(143, 143, 143, 0.76) !important;
      text-underline: #999999;
    }
  }
}
.permission-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000000;
  overflow: hidden;
  background: url('~@/assets/recycling/index/mengBanBg.png') no-repeat center;
  background-size: cover;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.3);
  animation: fadeIn 0.4s ease-in-out;
}

/* 背景蒙层 */
.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px); /* 背景模糊 */
  background-color: rgba(0, 0, 0, 0.7); /* 白色半透明 */
}

/* 弹窗容器 */
.modal-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.4s ease-in-out;
}

/* 弹窗卡片 */
.modal-card {
  width: 100%;
  max-width: 600px;
  padding: 36px 30px;
  text-align: center;
  transform: translateY(0);
  animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: relative;
  overflow: hidden;
  border-radius: 3.13px;
  background: #044069eb;
  box-shadow:
    inset 2px 2px 10px #1afffb,
    4px 4px 16px #002740;
  backdrop-filter: blur(4px);
}

///* 装饰性背景元素 */
//.modal-card::before {
//  content: '';
//  position: absolute;
//  top: 0;
//  left: 0;
//  width: 100%;
//  height: 6px;
//  background: linear-gradient(90deg, #409EFF, #67C23A);
//}

/* 图标样式 */
.modal-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background-color: #f0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-icon i {
  font-size: 40px;
  color: #409eff;
}

/* 标题样式 */
.modal-title {
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
  margin: 0 0 16px;
}

/* 消息内容 */
.modal-message {
  font-size: 20px;
  color: #ffffff;
  line-height: 1.6;
  margin: 0 0 30px;
  padding: 0 10px;
}

/* 按钮样式 */
.modal-actions {
  margin-top: 10px;
}

.back-button {
  min-width: 180px;
  //height: 44px;
  font-size: 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.back-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .modal-card {
    padding: 28px 20px;
    max-width: 90%;
  }

  .modal-title {
    font-size: 20px;
  }

  .modal-message {
    font-size: 15px;
  }
}
</style>
